import Pagination from "./Pagination";
import Filter from "./Filter";
import RequestBase from "./RequestBase";
export default class RequestHeroes extends RequestBase {
    /**
     * These IDs are required to make a request
     * @param {number} pageId The ID of the Page the SuperFlexi Module is published on
     * @param {number} moduleId The ID of the SuperFlexi Module
     */
    constructor(pageId, moduleId) {
        super(pageId, moduleId);
        this.Filter = new Filter();
        this.Pagination = new Pagination();
    }
}
